import React, { Component } from "react"
import OutsideClickTrigger from "../common/OutsideClickTrigger"
import config from "react-global-configuration"

class ParkingAcceptConditionsModal extends Component {
  render() {
    const { product, result } = this.props.item
    if (!this.props.isActive) return ""

    const isSpecialProduct = product && product.dynamicFields && product.dynamicFields.isSpecialProduct
    const specialProductLink = product && product.dynamicFields && product.dynamicFields.specialProductLink
    const specialProductText = product && product.dynamicFields && product.dynamicFields.specialProductText
    const specialProductLinkText = product && product.dynamicFields && product.dynamicFields.specialProductLinkText
    const textKeys = config.get("textKeys.parkingList.conditionsModal") || {}
    if (!isSpecialProduct) return ""

    const postCloseReservationCallback = this.props.buttonClickOverride
      ? () =>
          this.props.handleSpecialProductDetailsClose(() => {
            this.props.buttonClickOverride()
            this.props.handleSpecialProductDetailsCleanup()
          })
      : () =>
          this.props.handleSpecialProductDetailsClose(() =>
            this.props.handleReservation(product.id, this.props.item, this.props.handleSpecialProductDetailsCleanup),
          )

    return (
      <div className={"overlay overlay--modal overlay--fixed is-active"}>
        <div className="modal modal--large modal--parking-product-row-modal">
          <OutsideClickTrigger onOutsideClick={() => this.props.handleSpecialProductDetailsClose(this.props.handleSpecialProductDetailsCleanup)}>
            <React.Fragment>
              <button
                className="button button--icon js--close-modal"
                onClick={() => this.props.handleSpecialProductDetailsClose(this.props.handleSpecialProductDetailsCleanup)}
              >
                <span className="icon">
                  <svg className="svg-icon svg-icon--close-new">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                      &nbsp;
                    </use>
                  </svg>
                </span>
              </button>
              <div className="modal__content modal__content--no-padding">
                <div className="modal__content__inner">
                  <div className="modal__top">
                    <header>
                      <h3 className="headline-md">{textKeys.headline || "Bemærk venligst"}</h3>
                      <p>
                        <span dangerouslySetInnerHTML={{ __html: decodeURIComponent(specialProductText) }}></span>
                      </p>
                      <a className="button button--link" href={specialProductLink} target="_blank" rel="noopener noreferrer">
                        <span
                          className="text"
                          dangerouslySetInnerHTML={{ __html: decodeURIComponent(specialProductLinkText.toString().replace(/<[^>]*>/g, "")) }}
                        ></span>
                      </a>
                    </header>
                  </div>

                  <div className="modal__bottom">
                    <footer>
                      <h3>
                        {textKeys.valuta || "DKK"} {this.props.priceFormatter(result.totalPrice, true)}
                      </h3>
                      {!product.isSoldOut ? (
                        <button className="button button--small button--general" onClick={postCloseReservationCallback}>
                          <span className="text">{textKeys.reserve || "OK"}</span>
                        </button>
                      ) : (
                        <button className="button button--small button--general is-disabled">
                          <span className="text">{textKeys.soldOut || "Udsolgt"}</span>
                        </button>
                      )}
                    </footer>
                  </div>
                </div>
              </div>
            </React.Fragment>
          </OutsideClickTrigger>
        </div>
      </div>
    )
  }
}

export default ParkingAcceptConditionsModal
